<template>
	<div class="max-w-full lg:max-w-3xl mx-auto px-12 lg:px-0">
		<div class="text-2xl font-light text-gray-800">
	    What is your reason for needing a loan?
	  </div>
	 
	  <div class="flex flex-wrap mt-6 -mx-2">
	    <div class="w-full md:w-1/2 lg:w-1/4 px-2 mb-4">
	    	<a href="#" 
	    		:class="{ 'block bg-gray-200 p-3 rounded border hover:border-green-500 relative' : true, 'border-green-500' : primaryReason == 0 }" 
	    		@click.prevent="primaryReasonSelected(0)">
	    		
	    		<img src="https://img.icons8.com/color/96/000000/checked.png" 
	    			:class="{ 'inline w-6 absolute' : true, 'visible' : primaryReason == 0, 'invisible' : primaryReason != 0 }">

	    		<div class="text-center">
	    			<img src="https://img.icons8.com/color/96/000000/home.png" class="inline w-16">
	    		</div>

	    		<div class="text-center mt-2 text-sm">
	      		Buy Home
	      	</div>
	      </a>
	    </div>

	    <div class="w-full md:w-1/2 lg:w-1/4 px-2 mb-4">
	    	<a href="#" 
	    		:class="{ 'block bg-gray-200 p-3 rounded border hover:border-green-500 relative' : true, 'border-green-500' : primaryReason == 1 }" 
	    		@click.prevent="primaryReasonSelected(1)">

	    		<img src="https://img.icons8.com/color/96/000000/checked.png" 
	    			:class="{ 'inline w-6 absolute' : true, 'visible' : primaryReason == 1, 'invisible' : primaryReason != 1 }">

	    		<div class="text-center">
	    			<img src="https://img.icons8.com/color/96/000000/online-money-transfer.png" class="inline w-16">
	    		</div>

	    		<div class="text-center mt-2 text-sm">
	      		Debt Consolidate
	      	</div>
	      </a>
	    </div>

	    <div class="w-full md:w-1/2 lg:w-1/4 px-2 mb-4">
	    	<a href="#" 
	    		:class="{ 'block bg-gray-200 p-3 rounded border hover:border-green-500 relative' : true, 'border-green-500' : primaryReason == 2 }" 
	    		@click.prevent="primaryReasonSelected(2)">

	    		<img src="https://img.icons8.com/color/96/000000/checked.png" 
	    			:class="{ 'inline w-6 absolute' : true, 'visible' : primaryReason == 2, 'invisible' : primaryReason != 2 }">

	    		<div class="text-center">
	    			<img src="https://img.icons8.com/color/96/000000/bank-building.png" class="inline w-16">
	    		</div>

	    		<div class="text-center mt-2 text-sm">
	      		Refinance
	      	</div>
	      </a>
	    </div>

	    <div class="w-full md:w-1/2 lg:w-1/4 px-2 mb-4">	      
	    	<a href="#" 
	    		:class="{ 'block bg-gray-200 p-3 rounded border hover:border-green-500 relative' : true, 'border-green-500' : primaryReason == 3 }" 
	    		@click.prevent="primaryReasonSelected(3)">

	    		<img src="https://img.icons8.com/color/96/000000/checked.png" 
	    			:class="{ 'inline w-6 absolute' : true, 'visible' : primaryReason == 3, 'invisible' : primaryReason != 3 }">

	    		<div class="text-center">
	    			<img src="https://img.icons8.com/color/96/000000/sell-property.png" class="inline w-16">
	    		</div>

	    		<div class="text-center mt-2 text-sm">
	      		Buy Investment Property / Granny Flat
	      	</div>
	      </a>
	    </div>

	    <div class="w-full md:w-1/2 lg:w-1/4 px-2 mb-4">
	    	<a href="#" 
	    		:class="{ 'block bg-gray-200 p-3 rounded border hover:border-green-500 relative' : true, 'border-green-500' : primaryReason == 4 }" 
	    		@click.prevent="primaryReasonSelected(4)">

	    		<img src="https://img.icons8.com/color/96/000000/checked.png" 
	    			:class="{ 'inline w-6 absolute' : true, 'visible' : primaryReason == 4, 'invisible' : primaryReason != 4 }">

	    		<div class="text-center">
	    			<img src="https://img.icons8.com/color/96/000000/get-cash.png" class="inline w-16">
	    		</div>

	    		<div class="text-center mt-2 text-sm">
	      		Renovation / Cash Out
	      	</div>
	      </a>
	    </div>

	    <div class="w-full md:w-1/2 lg:w-1/4 px-2 mb-4">
	    	<a href="#" 
	    		:class="{ 'block bg-gray-200 p-3 rounded border hover:border-green-500 relative' : true, 'border-green-500' : primaryReason == 5 }" 
	    		@click.prevent="primaryReasonSelected(5)">

	    		<img src="https://img.icons8.com/color/96/000000/checked.png" 
	    			:class="{ 'inline w-6 absolute' : true, 'visible' : primaryReason == 5, 'invisible' : primaryReason != 5 }">

	    		<div class="text-center">
	    			<img src="https://img.icons8.com/color/96/000000/land-sales.png" class="inline w-16">
	    		</div>

	    		<div class="text-center mt-2 text-sm">
	      		Buy Land
	      	</div>
	      </a>
	    </div>

	    <div class="w-full md:w-1/2 lg:w-1/4 px-2 mb-4">
	    	<a href="#" 
	    		:class="{ 'block bg-gray-200 p-3 rounded border hover:border-green-500 relative' : true, 'border-green-500' : primaryReason == 7 }" 
	    		@click.prevent="primaryReasonSelected(7)">

	    		<img src="https://img.icons8.com/color/96/000000/checked.png" 
	    			:class="{ 'inline w-6 absolute' : true, 'visible' : primaryReason == 7, 'invisible' : primaryReason != 7 }">

	    		<div class="text-center">
	    			<img src="https://img.icons8.com/color/96/000000/bulldozer.png" class="inline w-16">
	    		</div>

	    		<div class="text-center mt-2 text-sm">
	      		Land &amp; Construction
	      	</div>
	      </a>
	    </div>

	    <div class="w-full md:w-1/2 lg:w-1/4 px-2 mb-4">
	    	<a href="#" 
	    		:class="{ 'block bg-gray-200 p-3 rounded border hover:border-green-500 relative' : true, 'border-green-500' : primaryReason == 6 }" 
	    		@click.prevent="primaryReasonSelected(6)">

	    		<img src="https://img.icons8.com/color/96/000000/checked.png" 
	    			:class="{ 'inline w-6 absolute' : true, 'visible' : primaryReason == 6, 'invisible' : primaryReason != 6 }">

	    		<div class="text-center">
	    			<img src="https://img.icons8.com/color/96/000000/asterisk.png" class="inline w-16">
	    		</div>

	    		<div class="text-center mt-2 text-sm">
	      		Other
	      	</div>
	      </a>
	    </div>

	    <div class="mt-2 ml-2 text-red-500 text-base" v-if="primaryReason == null && error != null">
	    	{{ error }}
	    </div>
	  </div>

	  <div class="mt-8">
	  	<a href="#" @click.prevent="next"
	  		:class="{ 
	  			'text-white py-4 rounded text-sm uppercase font-semibold inline-block px-16 overflow-hidden' : true, 
	  			'bg-blue-500 hover:bg-blue-600' : primaryReason != null, 
	  			'bg-gray-500' : primaryReason == null }">
	  		<div class="float-left">Next</div>

        <svg width="22" height="22" stroke-width="2" class="ml-4 float-left" stroke="currentColor" fill="none">
          <use xlink:href="/static/img/feather-sprite.svg#chevron-right"/>
        </svg>
	  	</a>
	  </div>
	</div>
</template>

<script>
  export default {
  	data() {
      return {
				primaryReason: null,
				lead         : null,
				error        : null
      }
    },

    created() {
    	if(this.$route.params.data != null) {
    		this.lead = JSON.parse(decodeURIComponent(this.$route.params.data))
    	} else {
    		this.lead = {}
    	}

    	if(this.lead.primaryReason != null) {
    		this.primaryReason = this.lead.primaryReason
    	}
    },

  	methods : {
  		primaryReasonSelected(primaryReason) {
  			this.primaryReason = primaryReason
  		},

  		next() {
  			this.error = null

  			if(this.primaryReason == null) {
  				this.error = 'Please select your primary reason for seeking credit.'
  			} 

  			else {
  				this.lead.primaryReason = this.primaryReason
  				this.$router.push({
						name  : 'client-lead-capture-contact',
						params: {
	  					data : encodeURIComponent(JSON.stringify(this.lead))
	  				}
	  			})
	  		}
  		}
  	}
  }
</script>